const LicencaDeUsoPage = () => (
  <div className="min-h-screen bg-[#F5F2EB] p-8">
    <div className="max-w-3xl mx-auto bg-white rounded-xl border p-8">
      <h1 className="font-serif text-3xl mb-4">Licença de Uso</h1>
      <p className="text-[#4A5568] leading-7">Documento placeholder para a licença de uso do PERYTUS.</p>
    </div>
  </div>
);

export default LicencaDeUsoPage;
